import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import SharedFiles from './components/SharedFiles';

const sharedFiles = (props,{ t }) => (
  <Container>
    <SharedFiles {...props} />
  </Container>
);

sharedFiles.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(sharedFiles);
